// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-medium);
}

.search-bar > * {
  flex: 0 0 15%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sensor/sensors-list/sensors-list.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,0BAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".search-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-medium);\n}\n\n.search-bar > * {\n  flex: 0 0 15%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
